import React, {useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {LockIcon, LockOpenIcon} from "@hugeicons/core-free-icons";
import {useFlowProtection} from "../hooks/useFlowProtection";
import {currentProtectionProjectId} from "../utils/flowProtectionStorage";
import {FlowProtectionAuthModal} from "./modals/FlowProtectionAuthModal";

/**
 * Icon button that opens a modal to enter a registry project's protection password.
 * Once unlocked, protected user messages of the project are shown unmasked
 * for a limited time (see useFlowProtection). Drop this next to the debug
 * toggle in any conversation toolbar. projectId defaults to the open registry project;
 * without one (old flow projects) nothing is rendered.
 */
export const FlowProtectionButton = ({projectId = currentProtectionProjectId(), size = "small", iconSize = 22}) => {
  const [open, setOpen] = useState(false);
  const {isUnlocked, unlock} = useFlowProtection(projectId);

  if (!projectId) return null;

  return (
    <>
      <Tooltip title={isUnlocked ? "Protected messages unlocked" : "Unlock protected messages"}>
        <IconButton
          size={size}
          color={isUnlocked ? "success" : "default"}
          onClick={() => setOpen(true)}
        >
          {isUnlocked ? <HugeiconsIcon icon={LockOpenIcon} size={iconSize}/> : <HugeiconsIcon icon={LockIcon} size={iconSize}/>}
        </IconButton>
      </Tooltip>
      <FlowProtectionAuthModal
        open={open}
        projectId={projectId}
        onClose={() => setOpen(false)}
        onSuccess={(token, expiresInSeconds) => unlock(token, expiresInSeconds)}
      />
    </>
  );
};
